import { render, staticRenderFns } from "./faqs.page.vue?vue&type=template&id=3f9fbe05&scoped=true&"
import script from "./faqs.page.vue?vue&type=script&lang=js&"
export * from "./faqs.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9fbe05",
  null
  
)

export default component.exports